<template>
	<div style="background: #f3f4f7" v-loading.fullscreen.lock="fullscreenLoading">
		<userHeader />
		<crumbs bTxt="退回上一级" />
		<div class="bodyWrapper">
			<div class="gudBtns">
				<div class="gudBtnItem gudBack supHove3" @click="$router.back()">
					<img src="@/assets/img/back.svg" alt="" />
					<span>返回</span>
				</div>
			</div>
			<div class="infoBox">
				<info @currCompBtn="currCompBtn" @lzFn="lzFn" />
				<keep-alive>
					<component :is="currentComponent" :csData="csData" @currCompBtn="currCompBtn" @lzFn="lzFn" :perData="perData"></component>
				</keep-alive>
			</div>
		</div>
		<foot />
	</div>
</template>

<script>
import foot from '@/components/foot/foot';
import crumbs from '@/components/hearder/crumbs';
import info from '@/components/pubComponents/info';
import userHeader from '@/components/hearder/userHeader';
import grXinx from '@/components/my/grXinx';
import zzAdmin from '@/components/my/zzAdmin';
import upZz from '@/components/my/upZz';
import jifenMy from '@/components/my/jifenMy';
import meiw from '@/components/my/meiw';
import yanJiang from '@/components/my/yanJiang';
import geQu from '@/components/my/geQu';
import dianYing from '@/components/my/dianYing';
import zuijinKs from '@/components/my/zuijinKs';
import meiqiKj from '@/components/my/meiqiKj';
import tongbuKj from '@/components/my/tongbuKj';
import kuozhanYd from '@/components/my/kuozhanYd';
import shuangyuXw from '@/components/my/shuangyuXw';
import meiriYt from '@/components/my/meiriYt';
import gaokaoZt from '@/components/my/gaokaoZt';
import shitiLz from '@/components/my/shitiLz';
import huzhuGx from '@/components/my/huzhuGx';
import changyongGj from '@/components/my/changyongGj';

export default {
	name: 'myInfo',
	data() {
		return {
			a: ['退回上一级'],
			currentComponent: 'grXinx',
			fullscreenLoading: false,
			infoData: {},
			csData: {},
			perData: []
		};
	},
	methods: {
		currCompBtn(cont, data) {
			if (data) {
				this.csData = data;
			} else {
				this.csData = {};
			}
			window.scrollTo(0, 0);
			this.currentComponent = cont;
		},
		init() {
			this.$http.get('api/app/login/getInfo').then((res) => {
				if (res.code == 200) {
					this.infoData = res.data;
					this.$store.commit('setInfoData', res.data);
				}
			});
		},
		lzFn() {
			this.fullscreenLoading = true;
			this.$http.get('api/app/yydQuestionBasket/list').then((res) => {
				this.fullscreenLoading = false;
				if (res.code == 200) {
					this.perData = res.rows || [];
					this.total = res.total;
				}
			});
		}
	},
	components: {
		userHeader,
		crumbs,
		foot,
		info,
		grXinx,
		zzAdmin,
		upZz,
		jifenMy,
		meiw,
		yanJiang,
		geQu,
		dianYing,
		zuijinKs,
		meiqiKj,
		tongbuKj,
		kuozhanYd,
		shuangyuXw,
		meiriYt,
		gaokaoZt,
		shitiLz,
		huzhuGx,
		changyongGj
	},
	// watch: {
	//   // '$route': {
	//   //   // handler(to) {
	//   //   //   if (to.meta.isBack) {
	//   //   //     console.log('这是返回操作')
	//   //   //     // 执行返回时的特定逻辑，例如刷新数据
	//   //   //     this.$store.commit('setCachedComponents',['xuanzMb','tihuanKt','banjiHome'])
	//   //   //     console.log('修改啦')
	//   //   //     setTimeout(() => {
	//   //   //       this.$store.commit('setCachedComponents',['myInfo', 'xuanzMb','tihuanKt','banjiHome'])
	//   //   //       console.log('存储缓存啦')
	//   //   //     }, 1000)
	//   //   //   } else {
	//   //   //     console.log('正常前进导航')
	//   //   //   }
	//   //   // },
	//   //   deep: true, // 启用深度监听
	//   //   immediate: true, // 立即执行一次
	//   // }
	// },
	activated() {
		let { routeName } = this.$route.query;
		if (routeName) {
			this.currentComponent = 'shitiLz';
			this.a = ['返回试题列表'];
			this.lzFn();
		}
		// else{
		//   this.currentComponent = 'grXinx'
		//   this.a = ['返回首页']
		// }
		this.init();
		console.log(this.currentComponent);
	}
};
</script>
<style lang="scss" scoped>
.infoBox {
	width: 1200px;
	margin: 0 auto 43px;
	display: flex;
}
</style>
